// extracted by mini-css-extract-plugin
module.exports = {"title":"Reporting_title__2K3IZ"};